import React, { useState } from "react";
import Alert from "./../Alert";

const ClearCache = () => {
  const [clearing, setClearing] = useState(false);
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");

  const clearLocalCache = () => {
    localStorage.clear();
    setSuccess(true);
    setMessage("All local cache cleared successfully.");
    window.location.href = "/";
  };

  const clearServerCache = async () => {
    setClearing(true);
    setSuccess(false);
    setError(false);
    setMessage("");

    try {
      const response = await fetch(
        "https://app.sustainchange.se/kinsta-clear-cache-all/"
      );

      const serverResponse = await response.text();

      if (serverResponse) {
        setSuccess(true);
        setMessage(serverResponse);
      }
    } catch (error) {
      console.log(error);
      setError(true);
      setMessage("Something went wrong. Please try again later.");
    }

    setClearing(false);
  };

  return (
    <div className="add-new-user-wrap">
      <h3 className="mb-4">Clear local and server cache</h3>
      <div className="form-text">
        Please use this <strong>only when it's absolutly necessary</strong>{" "}
        because, clearing cache directly affects to the speed of the platform
        and the server resources usage.
      </div>

      {success && (
        <div className="mt-2">
          <Alert type="success" msg={message} />
        </div>
      )}

      {error && (
        <div className="mt-2">
          <Alert type="danger" msg={message} />
        </div>
      )}
      <div className="mt-4 mb-lg-6 cache-row">
        <button
          className="btn btn-halite-blue btn-lg rounded-pill px-5"
          onClick={() => clearLocalCache()}
        >
          Clear local cache
        </button>
        <button
          className="btn btn-secondary btn-lg rounded-pill px-5"
          onClick={() => clearServerCache()}
        >
          <span>Clear server cache</span>
          {clearing && (
            <div
              className="spinner-border text-white spinner-border-sm ms-2"
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </div>
          )}
        </button>
      </div>
    </div>
  );
};

export default ClearCache;
